import React from 'react'
import ModalBody from 'components/Utils/Modal/Body'
import { MODAL_DEFAULT_STYLE } from 'components/Utils/Modal/style'
import ReactModal from 'react-modal'

export default function Modal({ isOpen, onModalClose, children }) {
  const style = {
    content: {
      ...MODAL_DEFAULT_STYLE.content,
      width: 460,
    },
    overlay: {
      ...MODAL_DEFAULT_STYLE.overlay,
    },
  }

  return (
    <ReactModal isOpen={isOpen} style={style} onRequestClose={onModalClose}>
      <ModalBody style={{ padding: 30 }}>{children}</ModalBody>
    </ReactModal>
  )
}
